import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/app/art/activities")({
  beforeLoad: ({ context: { t } }) => ({
    getTitle: () => t("Dispo"),
  }),
  component: Outlet,
})
